import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useAuth from '../Hooks/useAuth';
import { selectActiveRole } from '../Redux/Slice/adminAccessSlice';
import { canAccessAdminPath } from '../utils/rolePermissions';

/**
 * Protects admin routes:
 * 1. Requires superadmin authentication
 * 2. Enforces module permissions for the active role (blocks direct URL access)
 */
const RequireAdminAuth = () => {
  const { auth } = useAuth();
  const location = useLocation();
  const activeRole = useSelector(selectActiveRole);

  const isSuperAdmin = auth?.roleType === 'superadmin' && auth?.accessToken;
  const effectiveRole = activeRole || auth?.adminRole || null;
  const roleForCheck =
    effectiveRole || (isSuperAdmin ? { isFullAccess: true, modulePermissions: [] } : null);

  if (!isSuperAdmin) {
    if (auth?.accessToken) {
      return (
        <Navigate
          to="/unauthorized"
          state={{ from: location }}
          replace
        />
      );
    }

    return (
      <Navigate
        to="/admin"
        state={{ from: location }}
        replace
      />
    );
  }

  if (!canAccessAdminPath(location.pathname, roleForCheck)) {
    return (
      <Navigate
        to="/admin/dashboard"
        replace
      />
    );
  }

  return <Outlet />;
};

export default RequireAdminAuth;
